enum Subscriptions {
  home = '/subscriptions',
  createSubscription = '/subscriptions/create',
  showSubscription = '/subscriptions/:id',
}

export default Subscriptions;
